import { useQuery } from "hooks/useQuery";
import { getBrokerAccountRecentTrades } from "../service";

export const useBrokerAccountRecentTrades = () => {
  const { isLoading, data, error, refetch } = useQuery({
    key: "brokerAccountRecentTrades",
    queryKey: ["brokerAccountRecentTrades"],
    queryFn: () => getBrokerAccountRecentTrades(),
  });

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
